export const userAuthSuccess = userInfo => ({
  type: "AUTH_SUCCESS",
  userInfo
});
